/*
 * ConfirmSignUp Messages
 *
 * This contains all the text for the ConfirmSignUp component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.ConfirmSignUp';

export default defineMessages({
  confirmAccount: {
    defaultMessage: 'Confirm Your Account!',
  },
  alreadyConfirmed: {
    defaultMessage: 'Already Confirmed?',
  },
  signIn: {
    defaultMessage: 'Sign In',
  },
  sentConfirmation: {
    defaultMessage:
      'We have sent you a confirmation, please check your email and follow the link provided',
  },
});
